import { FaEdit } from 'react-icons/fa';
import styled from 'react-emotion';
import {
  space, color, width, fontSize,
} from 'styled-system';
import { bouncyBoyMixin } from '../../styles';

export const FlexWrapper = styled('section')`
  display: flex;
  flex: 1;
`;

export const DashboardLayoutWrapper = styled('section')`
  ${space}

  display: flex;
  flex: 4;
  min-width: 0;
  flex-direction: row;
  flex-wrap: wrap;
  position: relative;
`;

export const Column = styled('div')`
  ${width}
  ${space}
  height: 100%;
  display: flex;
  margin: 0 0.2rem;
  flex-direction: column;
`;

export const Row = styled('div')`
  ${space}
  display: flex;
  width: 100%;
  height: ${props => `${props.height * 100}%`};

  .DCRPCard {
    // TODO: Hacky, but this seems to be the easiest way to couple a card with its row height.
    // Make the font-size of a card directly proportional to its row height.
    // If a card is narrower than a half of the total dash height, increase the proportion by 3x.
    font-size: ${props => `${(props.height < 0.5) ? props.height * 300 : 100}%`};
  }
`;

export const EditLayoutButton = styled(FaEdit, {
  shouldForwardProp: prop => !['editorOpen'].includes(prop),
})`
  ${space}
  ${fontSize}
  ${color}
  
  display: ${({ editorOpen }) => editorOpen && 'none'};
  position: absolute;
  top: 0;
  left: 0;
  cursor: pointer;

  &:hover {
    color: #333;
  }

  ${bouncyBoyMixin}
`;